import React from "react";
import { useApplication } from "../../contexts/ApplicationContext";

const FooterQuery = ({ hasHeader = "true" }) => {
  const { user } = useApplication();
  return (
    <>
      {hasHeader === "true" && (
        <>
          {user?.Company?.showLogo && (
            <>
              <div className="mb-20"></div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default FooterQuery;
